import { render, staticRenderFns } from "./ProjectAuditLogTable.vue?vue&type=template&id=1ba8df95&scoped=true&"
import script from "./ProjectAuditLogTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectAuditLogTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAuditLogTable.vue?vue&type=style&index=0&id=1ba8df95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8df95",
  null
  
)

export default component.exports